import api from 'utils/api';
import { slotConfig } from 'utils/api';

export const ClaimsService = {
    postClaim: (body: FormData): void => {
        api.post(`${process.env.REACT_APP_CLAIMS_API_URL}`, body, slotConfig);
    },

    postClaimWithResponse: (body: FormData): any => {
        return api.post(`${process.env.REACT_APP_CLAIMS_API_URL}`, body, slotConfig);
    }
};
